import React from 'react';
import { Box, Typography } from '@mui/material';

const ProjectListItem = ({ project, onSelect, userType, proposalStatus, applicationStatus }) => {
  // Function to determine color and label text for Employer statuses
  const getEmployerStatusTag = (status) => {
    switch (status) {
      case 'Saved':
        return { color: '#e9e4dc', text: 'Saved', textColor: 'white' };
      case 'Submitted':
        return { color: '#732f2f', text: 'Published', textColor: 'white' };
      case 'Withdrawn':
        return { color: '#3c0000', text: 'Cancelled', textColor: 'white' };
      case 'Closed':
        return { color: '#500000', text: 'Closed', textColor: 'white' };
      default:
        return null;
    }
  };

  // Function to determine color and label text for Student Proposal Status
  const getProposalStatusTag = (status) => {
    switch (status) {
      case 'Saved':
        return { color: '#732f2f', text: 'Proposal: Saved', textColor: 'white' };
      case 'Submitted':
        return { color: '#732f2f', text: 'Proposal: Submitted', textColor: 'white' };
      case 'Withdrawn':
      case 'Closed':
        return { color: '#3c0000', text: 'Proposal: Withdrawn', textColor: 'white' };
      case null:
        return { color: '#707070', text: 'Yet to Submit', textColor: 'white' }; // No proposal submitted
      default:
        return null;
    }
  };

  // Function to determine color and label text for Student application decision status
  // (Displayed as "Proposal: <Decision>" per UX request.)
  const getApplicationStatusTag = (status) => {
    switch (status) {
      case 'In Review':
        return { color: '#3e3e3e', text: 'Proposal: In Review', textColor: 'white' };
      case 'Accepted':
        return { color: '#732f2f', text: 'Proposal: Accepted', textColor: 'white' };
      case 'Rejected':
        return { color: '#3c0000', text: 'Proposal: Rejected', textColor: 'white' };
      default:
        return null;
    }
  };

  const employerTag = getEmployerStatusTag(project.projectStatus);
  const normalizedProposalStatus = proposalStatus === 'Closed' ? 'Withdrawn' : proposalStatus;
  const proposalTag = getProposalStatusTag(normalizedProposalStatus);
  const applicationTag = getApplicationStatusTag(applicationStatus);

  return (
    <Box
      display="flex"
      flexDirection="column" // Stack content vertically
      padding={2}
      paddingBottom={5}
      marginBottom={1}
      border="1px solid #d1d1d1"
      borderRadius="8px"
      onClick={() => onSelect(project.projectID)}
      style={{ cursor: 'pointer', position: 'relative', backgroundColor: '#f6f6f6' }}
    >
      {/* Project Details */}
      <Box>
        <Typography fontWeight="bold" variant="subtitle1">
          {project.requestTitle}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Proposal Deadline: {project.proposalDeadline}
        </Typography>
      </Box>
  
      {/* Status Tags */}
      <Box
        position="absolute" // Positioned at the bottom-right corner
        bottom="8px"
        right="8px"
        display="flex"
        gap={1} // Space between tags
        flexWrap="wrap"
      >
        {/* Status Tags for Employer */}
        {userType === 'Employer' && employerTag && (
          <Box
          bgcolor={employerTag.color}
          padding="2px 6px" // Reduce padding
          borderRadius="3px" // Reduce border radius
          color={employerTag.textColor}
          fontSize="0.75rem" // Reduce font size
          fontWeight="bold"
          style={{
            whiteSpace: 'nowrap',
            boxShadow: employerTag.text === 'Saved' ? '0px 0px 4px rgba(0, 0, 0, 0.2)' : 'none',
          }}
        >
          {employerTag.text}
        </Box>
        )}
  
        {/* Status Tags for Student */}
        {userType === 'Student' && proposalTag && (
          <Box
          bgcolor={proposalTag.color}
          padding="2px 6px"  // Reduce padding
          borderRadius="3px"  // Reduce border radius
          color={proposalTag.textColor}
          fontSize="0.75rem"  // Reduce font size
          fontWeight="bold"
          style={{ whiteSpace: 'nowrap' }}
        >
          {proposalTag.text}
        </Box>
        )}
  
        {userType === 'Student' && normalizedProposalStatus === 'Submitted' && applicationTag && (
         <Box
         bgcolor={applicationTag.color}
         padding="2px 6px" // Reduce padding
         borderRadius="3px" // Reduce border radius
         color={applicationTag.textColor}
         fontSize="0.75rem" // Reduce font size
         fontWeight="bold"
         style={{ whiteSpace: 'nowrap' }}
       >
         {applicationTag.text}
       </Box>
        )}
      </Box>
    </Box>
  );
};

export default ProjectListItem;
